var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopped({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.018,
    height: 20.018,
    viewBox: "0 0 20.018 20.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    d: "M10.009,0A10.009,10.009,0,1,0,20.018,10.009,10.02,10.02,0,0,0,10.009,0Zm4.17,13.762a.417.417,0,0,1-.417.417H6.256a.417.417,0,0,1-.417-.417V6.256a.417.417,0,0,1,.417-.417h7.507a.417.417,0,0,1,.417.417Z",
    fill: "#fea522"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopped);
export default __webpack_public_path__ + "static/media/stopped.0c1d201cadcca275b8bc322ff43e02f8.svg";
export { ForwardRef as ReactComponent };